import React from 'react';

export default function VideosPage() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Videos</h1>
      <p>Videos page not implemented yet.</p>
    </div>
  );
}